import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { AirSearchHeaderActionService } from './air-search-header-action.service';
import { EWayType } from "../../air-search-form/air-search-segment-oneway-return/air-search-segment-oneway-return.component";
import { Subscription } from 'rxjs';
import { EAirSearchContext } from '../../../air-search/air-search.component';
import { ExternalApplicationService } from '../../../service/external-application/external-application.service';

export class Wording {
    public readonly resetAirSearchForm: string = Yii.t('wui-iqba-js', 'Nouvelle Recherche');
    public readonly oneWay: string = Yii.t('wui-iqba-js', 'Aller Simple');
    public readonly roundWay: string = Yii.t('wui-iqba-js', 'Aller-Retour');
    public readonly multipleWay: string = Yii.t('wui-iqba-js', 'Recherche avancée');
    public readonly openForm: string = Yii.t('wui-iqba-js', 'Modifier la recherche');
    public readonly closeForm: string = Yii.t('wui-iqba-js', 'Fermer');
    public readonly redirectionToWatabi: string = Yii.t('wui-iqba-js', 'Retour à Watabi');
}

@Component({
    selector: 'air-search-header-action',
    templateUrl: './air-search-header-action.component.html',
    styleUrls: ['./air-search-header-action.component.scss']
})
export class AirSearchHeaderActionComponent implements OnInit, OnDestroy {
    @Input()
    public hasAirSearchRequest: boolean;
    @Input()
    public canUseAirSearchForm: boolean = false;
    @Input()
    public isAirSearchFormVisible: boolean;
    @Input()
    public airSearchContext: EAirSearchContext = null;
    public eAirSearchContext: typeof EAirSearchContext = EAirSearchContext;
    public readonly wording: Wording = new Wording();
    public wayType: EWayType = EWayType.Return;
    public eWayType: typeof EWayType = EWayType;
    private airSearchHeaderActionSubscription: Subscription;
    constructor(
        private readonly airSearchHeaderActionService: AirSearchHeaderActionService,
        private readonly externalApplicationService: ExternalApplicationService,
    ) { }

    public ngOnInit(): void {
        this.initAirSearchHeaderActionSubscription();
    }

    public ngOnDestroy(): void {
        this.airSearchHeaderActionSubscription.unsubscribe();
    }

    public changeWayType(wayType: EWayType): void {
        this.wayType = wayType;
        this.airSearchHeaderActionService.onWayTypeChange(this.wayType);
    }

    public resetAirSearchForm(): void {
        this.airSearchHeaderActionService.onResetAirSearchForm();
    }

    public closeAirSearchForm(): void {
        this.isAirSearchFormVisible = !this.isAirSearchFormVisible;
        this.airSearchHeaderActionService.onToggleIsAirSearchFormVisible(this.isAirSearchFormVisible);
    }

    public redirectionToWatabi(): void {
        sessionStorage.removeItem("IQBA_ExternalApplicationData");
        sessionStorage.removeItem("$post");
        window.location.href = this.externalApplicationService.getExternalApplicationLocation();
    }

    private initAirSearchHeaderActionSubscription() {
        this.airSearchHeaderActionSubscription =
            this.airSearchHeaderActionService.wayTypeChangeObservable.subscribe((wayType: EWayType) => {
                this.wayType = wayType;
            });
    }

}
